import createVueComponent from '../createVueComponent';

const ChevronLast = createVueComponent('ChevronLastIcon', [
  ['polyline', { points: '7 18 13 12 7 6' }],
  ['path', { d: 'M17 6v12' }],
]);

export default ChevronLast;
